import React, { useEffect, useState } from 'react';
import '../css/MobileRestriction.css';

const MIN_WIDTH = 768;

const MobileRestriction: React.FC = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MIN_WIDTH);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < MIN_WIDTH);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!isMobile) return null;

    return (
        <div className="mobile-restriction-overlay">

            {/* Inline SVG — desktop monitor illustration */}
            <svg
                className="mobile-restriction-icon"
                viewBox="0 0 200 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Monitor body */}
                <rect x="20" y="10" width="160" height="100" rx="8" fill="#E8EAF6" stroke="#5C6BC0" strokeWidth="3" />
                {/* Screen */}
                <rect x="30" y="20" width="140" height="75" rx="4" fill="#C5CAE9" />
                {/* Screen content lines */}
                <rect x="50" y="38" width="80" height="6" rx="3" fill="#7986CB" />
                <rect x="60" y="52" width="60" height="6" rx="3" fill="#9FA8DA" />
                <rect x="55" y="66" width="70" height="6" rx="3" fill="#9FA8DA" />
                {/* Stand */}
                <rect x="85" y="112" width="30" height="14" rx="2" fill="#5C6BC0" />
                {/* Base */}
                <rect x="60" y="126" width="80" height="8" rx="4" fill="#5C6BC0" />
                {/* Checkmark circle */}
                <circle cx="160" cy="30" r="16" fill="#66BB6A" />
                <path d="M152 30l5 5 10-10" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <h1 className="mobile-restriction-title">
                CPASS is optimized for desktop
            </h1>
            <p className="mobile-restriction-body">
                To access all features of CPASS, please open this page on a
                device with a wider screen such as a tablet, laptop, or desktop computer.
            </p>
        </div>
    );
};

export default MobileRestriction;
